import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Image,
  Text,
  Button,
  VStack,
  Badge,
  Icon,
  Avatar,
  SimpleGrid,
  Card,
  CardBody,
  CardFooter,
  Heading,
  HStack,
} from "@chakra-ui/react";
import { Bar } from "react-chartjs-2";

import { EditIcon } from "@chakra-ui/icons";
import { FaClock } from "react-icons/fa";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Doughnut, Line } from "react-chartjs-2"; // Import Line from react-chartjs-2
import "chart.js/auto";
import Gra from "./Graph";
import {
  FaExclamationCircle,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import NoticeBoard from "../Admin/NoticeBoard";
import EventBoard from "../Admin/EventBoard";
import Component_Teacher_Bus from "../Bus/TeacherBusFee/Component_Teacher_Bus";
import { BASE_URL } from "../../Globalapi/Globalapi";
import LeaveStatusCard from "./Leave_Status";
import axios from "axios";
import ExamResultsChart from "./ExamResultsChart";

const ProfileCard = () => {
  const [date, setDate] = useState(new Date());
  const [timetableData, setTimetableData] = useState([]);
  const [studentId] = useState(2);
  const [userData, setUserData] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [students, setStudents] = useState([]);
  const [boysCount, setBoysCount] = useState(0);
  const [girlsCount, setGirlsCount] = useState(0);

  const userId = sessionStorage.getItem("user_id"); // Retrieve user ID from session
  const userType = sessionStorage.getItem("user_type");

  const genderData = {
    labels: ["Boys", "Girls"],
    datasets: [
      {
        data: [boysCount, girlsCount], // <--- Using the state variables
        backgroundColor: ["#ADD8E6", "#FFB6C1"],
        hoverBackgroundColor: ["#87CEEB", "#FF69B4"],
      },
    ],
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${BASE_URL}/student/all_profile.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_type: userType, user_id: userId }),
        });
        if (!response.ok) throw new Error("Network response was not ok");
        const data = await response.json();
        setUserData(data.data);
        console.log("====================================");
        console.log("staff profile", data.data);
        console.log("====================================");
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, [userType, userId]);

  const fetchClassStudents = async () => {
    try {
      const user_id = sessionStorage.getItem("user_id");
      if (!user_id) {
        setError("No user ID found.");
        setLoading(false);
        return;
      }
      const response = await axios.post(
        `${BASE_URL}/staff/class/class_students.php `,
        { pass: user_id },
        { headers: { "Content-Type": "application/json" } }
      );
      console.log("class_students", response);

      if (response.data.success) {
        setStudents(response.data.data);
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      console.error("API call error:", err);
      setError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on mount
  useEffect(() => {
    fetchClassStudents();
  }, []);

  // Inside ProfileCard component
  const calculateGenderDistribution = (studentList) => {
    if (!studentList || studentList.length === 0) {
      setBoysCount(0);
      setGirlsCount(0);
      return;
    }

    const maleCount = studentList.filter(
      (student) => student.gender && student.gender.toLowerCase() === "male"
    ).length;

    const femaleCount = studentList.filter(
      (student) => student.gender && student.gender.toLowerCase() === "female"
    ).length;

    setBoysCount(maleCount);
    setGirlsCount(femaleCount);
  };

  useEffect(() => {
    calculateGenderDistribution(students);
  }, [students]); // Recalculate whenever the students array updates

  const examData = {
    labels: ["Math", "Science", "History", "English", "Geography"], // Subjects or Exams
    datasets: [
      {
        label: "Minimum Marks",
        data: [30, 35, 25, 28, 40], // Minimum marks
        // Key Bar Chart properties
        backgroundColor: "rgba(255, 99, 132, 0.6)", // Solid color for the bar
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
      {
        label: "Maximum Marks",
        data: [90, 85, 88, 92, 80], // Maximum marks
        // Key Bar Chart properties
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
      {
        label: "Student Marks",
        data: [75, 65, 70, 80, 60], // Student's marks
        // Key Bar Chart properties
        backgroundColor: "rgba(49, 130, 206, 0.8)", // Darker Blue
        borderColor: "#3182CE",
        borderWidth: 1,
      },
    ],
  };
  const examOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          // Set usePointStyle to false for standard bar chart legend keys
          usePointStyle: false,
          padding: 20,
          font: {
            family: "Poppins",
          },
        },
      },
      title: {
        display: true,
        text: "Performance Comparison (Bar Chart)",
        font: {
          size: 16,
          family: "Poppins",
        },
        padding: 15,
      },
      tooltip: {
        mode: "index", // Important for seeing all 3 data points when hovering over a bar
        intersect: false,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        padding: 10,
      },
    },
    scales: {
      y: {
        min: 0,
        max: 100, // Set fixed max mark for consistency
        title: {
          display: true,
          text: "Marks",
        },
        ticks: {
          stepSize: 10,
          font: { family: "Poppins" },
        },
        grid: {
          color: "rgba(200, 200, 200, 0.2)", // Lighter grid lines
        },
      },
      x: {
        // The x-axis is now a category axis for bars
        title: {
          display: true,
          text: "Subjects",
        },
        ticks: {
          font: { family: "Poppins" },
        },
        grid: {
          display: false, // Hide vertical grid lines
        },
      },
    },
    // Setting the hover mode to 'index' is usually best for bar charts
    hover: {
      mode: "index",
      intersect: false,
    },
  };

  useEffect(() => {
    const fetchTimetable = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/timetable/list_timetable_to_student.php`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ student_id: studentId }),
          }
        );
        const data = await response.json();
        if (data.success) {
          setTimetableData(data.timeTable || []);
        } else {
          console.error("Error fetching timetable:", data.message);
        }
      } catch (error) {
        console.error("Error fetching timetable:", error);
      }
    };

    fetchTimetable();
  }, [studentId]);

  const getStatus = (fromTime, toTime) => {
    const now = new Date();
    const fromTimeDate = new Date(`1970-01-01T${fromTime}`);
    const toTimeDate = new Date(`1970-01-01T${toTime}`);

    if (now > toTimeDate) return "Completed";
    if (now >= fromTimeDate && now <= toTimeDate) return "In Progress";
    return "Upcoming";
  };

  const filteredTimetableData = timetableData.filter(
    (classItem) => classItem.day === "Friday"
  );
  const sortedTimetableData = filteredTimetableData
    .slice()
    .sort(
      (a, b) =>
        new Date(`1970-01-01T${a.start_time}`) -
        new Date(`1970-01-01T${b.start_time}`)
    );

  const leaveData = [
    {
      type: "Emergency Leave",
      date: "15 Jun 2024",
      status: "Pending",
      statusColor: "blue",
      icon: FaExclamationCircle,
    },
    {
      type: "Medical Leave",
      date: "15 Jun 2024",
      status: "Approved",
      statusColor: "green",
      icon: FaCheckCircle,
    },
    {
      type: "Medical Leave",
      date: "16 Jun 2024",
      status: "Declined",
      statusColor: "red",
      icon: FaTimesCircle,
    },
    {
      type: "Not Well",
      date: "16 Jun 2024",
      status: "Approved",
      statusColor: "green",
      icon: FaCheckCircle,
    },
  ];
  if (loading) {
    return (
      <Box p={6} bg="white" borderRadius="xs" shadow="md">
        <Text color="black">Loading profile data...</Text>
      </Box>
    );
  }

  return (
    <Box bg="#f7fafc" p={8} minHeight="100vh">
      <Flex direction={{ base: "column", lg: "row" }} gap={5}>
        {/* Left Side */}
        <Flex direction="column" flex="2" gap={6}>
          {/* Profile Section */}
          <Box
            borderColor="gray.300"
            p={6}
            bg="white"
            borderRadius="xs"
            color="white"
            position="relative"
            shadow="md"
            maxH={{ base: "auto", md: "200px" }}
            // boxShadow="md"
            _hover={{
              transform: "scale(1.01)",
              transition: "0.3s ease-in-out",
            }}
          >
            {loading ? (
              <Text color="black">Loading Profile...</Text>
            ) : (
              <Flex
                alignItems="center"
                justify="space-between"
                direction={{ base: "column", md: "row" }} // Stack elements vertically in mobile view
              >
                <Flex
                  alignItems="center"
                  direction={{ base: "column", md: "row" }}
                  mb={{ base: 4, md: 0 }}
                >
                  <Avatar
                    size="2xl"
                    name={userData?.name}
                    src={userData?.image_url}
                    mr={{ base: 0, md: 6 }} // Remove margin in mobile view
                    mb={{ base: 4, md: 0 }} // Add margin in mobile view for spacing
                  />
                  <VStack
                    align="start"
                    color="black"
                    spacing={2}
                    textAlign={{ base: "center", md: "start" }}
                  >
                    <Text fontWeight="bold" fontSize="2xl" color="black">
                      {userData.name}
                    </Text>
                    <Text fontSize="lg">
                      Classes: {userData.class}-{userData.division}
                    </Text>
                    <Text fontSize="lg">Employee No: 12312</Text>
                  </VStack>
                </Flex>
              </Flex>
            )}

            {/* Edit Profile Button (optional) */}
            {/* Uncomment this section if you want an "Edit Profile" button */}
            {/* <Button
    leftIcon={<EditIcon />}
    colorScheme="whiteAlpha"
    variant="outline"
    position="absolute"
    top={4}
    right={4}
  >
    Edit Profile
  </Button> */}
          </Box>

          <NoticeBoard />
          <EventBoard />
          {/* Timetable */}
          <Box
            bg="white"
            p={6}
            borderRadius="xs"
            boxShadow="lg"
            overflowY="auto"
          >
            <Text fontWeight="bold" fontSize="lg" mb={4} color="blue.600">
              Today's Timetable
            </Text>
            <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={4}>
              {sortedTimetableData.length > 0 ? (
                sortedTimetableData.map((classItem, index) => (
                  <Card
                    key={index}
                    bg="gray.50"
                    boxShadow="sm"
                    _hover={{
                      boxShadow: "lg",
                      transform: "translateY(-2px)",
                      transition: "0.3s",
                    }}
                  >
                    <CardBody>
                      <Flex justifyContent="space-between" alignItems="center">
                        <VStack align="start">
                          <Heading size="md">{classItem.subject}</Heading>
                          <Text color="gray.600">
                            <Icon as={FaClock} mr={2} />
                            {classItem.start_time} - {classItem.end_time}
                          </Text>
                        </VStack>
                        <Badge
                          colorScheme={
                            getStatus(
                              classItem.start_time,
                              classItem.end_time
                            ) === "Completed"
                              ? "green"
                              : getStatus(
                                  classItem.start_time,
                                  classItem.end_time
                                ) === "In Progress"
                              ? "yellow"
                              : "blue"
                          }
                          variant="solid"
                        >
                          {getStatus(classItem.start_time, classItem.end_time)}
                        </Badge>
                      </Flex>
                    </CardBody>
                  </Card>
                ))
              ) : (
                <Text>No classes scheduled for today.</Text>
              )}
            </SimpleGrid>
          </Box>
          <Gra />

          {/* Exam Results Line Chart */}
          <Box bg="white" p={6} borderRadius="xs" boxShadow="md">
            {/* <Text fontWeight="bold" fontSize="lg" mb={4} color="blue.600">
              Exam Results Comparison
            </Text>
            <div style={{ height: "400px", width: "100%" }}>
              <Bar data={examData} options={examOptions} />
            </div> */}
            <ExamResultsChart />
          </Box>
        </Flex>

        {/* Right Side */}
        <Flex direction="column" flex="1" gap={5}>
          <Box bg="white" p={6} borderRadius="xs" boxShadow="md">
            {/* <Text fontWeight="bold" fontSize="lg" mb={4}>
              Gender Distribution
            </Text> */}
            <div style={{ width: "100%" }}>
              <Component_Teacher_Bus />
            </div>
          </Box>

          {/* Gender Distribution */}
          <Box bg="white" p={6} borderRadius="xs" boxShadow="lg">
            <Text fontWeight="bold" fontSize="lg" mb={4}>
              Gender Distribution
            </Text>
            <div style={{ height: "375px", width: "100%" }}>
              <Doughnut data={genderData} />
            </div>
          </Box>

          <LeaveStatusCard data={leaveData} />

          {/* Calendar */}
          <Box
            bg="white"
            p={6}
            borderRadius="xs"
            boxShadow="lg"
            // ADDED: Set a max width for the overall component on large screens
            // and ensure it takes full width on small screens
            maxW={{ base: "100%", md: "xl", lg: "2xl" }}
            mx="auto" // Centers the box horizontally
          >
            <Text fontWeight="bold" fontSize="lg" mb={4} color="blue.500">
              Schedules
            </Text>
            <Box
              bg="gray.50"
              borderRadius="md"
              p={4}
              border="1px solid #e2e8f0"
              boxShadow="md"
              maxW="100%"
            >
              <Calendar
                onChange={setDate}
                value={date}
                tileClassName={({ date, view }) =>
                  view === "month" && date.getDate() === new Date().getDate()
                    ? "react-calendar__tile--active"
                    : undefined
                }
              />
              <style jsx global>{`
                /* CRITICAL FOR RESPONSIVENESS:
        This ensures the calendar scales to the width of its parent container.
      */
                .react-calendar {
                  font-family: "Poppins", sans-serif;
                  border: none;
                  width: 100%; /* Ensures full width on all screens */
                  box-sizing: border-box; /* Good practice for responsive containers */
                }

                .react-calendar__month-view__days__day {
                  font-family: "Poppins", sans-serif;
                }

                .react-calendar__tile {
                  font-family: "Poppins", sans-serif;
                  border-radius: 4px;
                  padding: 10px;
                  transition: background-color 0.3s;
                }

                /* OPTIONAL: Adjust padding for very small phone screens to prevent overflow */
                @media (max-width: 380px) {
                  .react-calendar__tile {
                    padding: 5px; /* Reduce padding to ensure the days fit without wrapping */
                  }
                }

                .react-calendar__tile--active {
                  background-color: #3182ce;
                  color: white;
                  border-radius: 4px;
                }
                .react-calendar__tile:hover {
                  background-color: #ebf8ff;
                }
              `}</style>
            </Box>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};

export default ProfileCard;
